<template>
  <div class="scroll_flex_container">
    <storeBanner :store="storeName" :showVipCard="true" />
    <OnlineOrder></OnlineOrder>
  </div>
</template>

<script>
import storeBanner from "../../components/store/storeBanner.vue";
import OnlineOrder from "./OnlineOrder.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    storeBanner: storeBanner,
    OnlineOrder: OnlineOrder,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters('basic', {
      storeName: 'storeName',
    }),
  },
};
</script>

<style lang="scss">
.box {
  height: 100px;
  width: 100px;
  background-color: #000000;
}
</style>
